/*
 * HARUM (HAR-282): open Shopify Inbox from a link.
 *
 * Customer emails from supply.harum.io carry an "Enquiry on order no N" button
 * that lands on https://www.harum.io/?harum_chat=open&harum_chat_msg=...
 * This opens the Inbox widget and types the message into its box, so the
 * customer only has to press send. Nothing is sent for them.
 *
 * Inbox has no documented API, so we click its own launcher (same approach as
 * the dashboard's "Chat With Us", assets/harum-customer-dashboard.js) and look
 * for the composer inside its shadow root. If the widget never shows up we stop
 * quietly after ~15 s; the customer is still on the store.
 */
(function () {
  const params = new URLSearchParams(window.location.search);
  if (params.get('harum_chat') !== 'open') return;
  const message = (params.get('harum_chat_msg') || '').slice(0, 200);

  const LAUNCHERS = ['shopify-chat', 'inbox-online-store-chat', '#ShopifyChat', '[id^="ShopifyChat"]'];
  const DEADLINE = Date.now() + 15000;

  function widget() {
    for (let i = 0; i < LAUNCHERS.length; i += 1) {
      const node = document.querySelector(LAUNCHERS[i]);
      if (node) return node;
    }
    return null;
  }

  function query(node, selector) {
    const root = node.shadowRoot || node;
    return root.querySelector(selector);
  }

  function fill(box) {
    const proto = box instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    const setter = Object.getOwnPropertyDescriptor(proto, 'value').set;
    setter.call(box, message);
    box.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    box.focus();
  }

  /* Drop the params so a reload or a shared link does not reopen the chat. */
  function clean() {
    params.delete('harum_chat');
    params.delete('harum_chat_msg');
    const query = params.toString();
    window.history.replaceState(null, '', window.location.pathname + (query ? `?${query}` : '') + window.location.hash);
  }

  let opened = false;
  function tick() {
    if (Date.now() > DEADLINE) return;
    const node = widget();
    if (node) {
      if (!opened) {
        const launcher = query(node, 'button, [role="button"]');
        if (launcher && typeof launcher.click === 'function') {
          launcher.click();
          opened = true;
          clean();
          if (!message) return;
        }
      } else {
        const box = query(node, 'textarea, input[type="text"]');
        if (box) {
          fill(box);
          return;
        }
      }
    }
    window.setTimeout(tick, 300);
  }

  if (document.readyState === 'complete') tick();
  else window.addEventListener('load', tick);
})();
